"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _configProvider = require("../config-provider/configProvider");
var _icon = require("../icon");
var _loading = require("../loading");
var _utils = require("../utils");
var _ButtonLink = _interopRequireDefault(require("./ButtonLink"));
var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup"));
var _excluded = ["onClick", "htmlType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var buttonRef = (0, _react.useRef)(null);
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var PREFIX = getPrefixCls('button');
  var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    icon = props.icon,
    rightIcon = props.rightIcon,
    children = props.children,
    size = props.size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'normal' : _props$type,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? 'rect' : _props$shape,
    _props$hoverShape = props.hoverShape,
    hoverShape = _props$hoverShape === void 0 ? false : _props$hoverShape,
    className = props.className,
    _props$dashed = props.dashed,
    dashed = _props$dashed === void 0 ? false : _props$dashed,
    _props$ghost = props.ghost,
    ghost = _props$ghost === void 0 ? false : _props$ghost,
    _props$isLink = props.isLink,
    isLink = _props$isLink === void 0 ? false : _props$isLink;
  var getClassName = function getClassName() {
    // 只有存在图标的情况，用于控制左右padding和margin，这里把rightIcon当做children的一种来处理
    var onlyOneIcon = !(children || rightIcon);
    return (0, _classnames.default)(className, PREFIX, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(PREFIX, "-dashed"), dashed), "".concat(PREFIX, "-ghost"), ghost), "".concat(PREFIX, "-disabled"), disabled), "".concat(PREFIX, "-loading"), loading), "".concat(PREFIX, "-").concat(type), type !== 'normal'), "".concat(PREFIX, "-").concat(shape).concat(hoverShape ? '-hover' : ''), 'rect'), "".concat(PREFIX, "-").concat(size), size && size !== 'normal'), "".concat(PREFIX, "-with-only-icon"), onlyOneIcon));
  };
  var getElementType = function getElementType() {
    return isLink ? 'a' : 'button';
  };
  var getElementProps = function getElementProps() {
    var onClick = props.onClick,
      _props$htmlType = props.htmlType,
      htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType,
      other = (0, _objectWithoutProperties2.default)(props, _excluded);
    var hanlderClick = function hanlderClick(event) {
      if (!disabled && !loading && onClick) {
        onClick(event);
      }
      if (disabled || loading) {
        event.preventDefault();
      }
    };
    // 过滤非原生属性
    var htmlElementProps = _objectSpread(_objectSpread({}, (0, _utils.dropProps)(other, ['children', 'size', 'shape', 'hoverShape', 'icon', 'rightIcon', 'ghost', 'dashed', 'loading', 'disabled', 'type', 'isLink'])), {}, {
      className: getClassName(),
      onClick: hanlderClick,
      onMouseLeave: handleMouseLeave
    });
    if (isLink) {
      htmlElementProps;
      // @ts-ignore
      var _elementProps = _objectSpread({}, htmlElementProps);
      return _elementProps;
    }
    htmlElementProps;
    var elementProps = _objectSpread(_objectSpread({
      ref: buttonRef
    }, htmlElementProps), {}, {
      type: htmlType
    });
    return elementProps;
  };
  var handleMouseLeave = function handleMouseLeave(e) {
    var _buttonRef$current;
    var onMouseLeave = props.onMouseLeave;
    if ((0, _utils.isFunction)((_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.blur)) {
      var _buttonRef$current2;
      (_buttonRef$current2 = buttonRef.current) === null || _buttonRef$current2 === void 0 || _buttonRef$current2.blur();
    }
    if ((0, _utils.isFunction)(onMouseLeave)) {
      onMouseLeave(e);
    }
  };
  var iconOnly = !(children || rightIcon);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        var _buttonRef$current3;
        return (_buttonRef$current3 = buttonRef.current) === null || _buttonRef$current3 === void 0 ? void 0 : _buttonRef$current3.focus();
      },
      blur: function blur() {
        var _buttonRef$current4;
        return (_buttonRef$current4 = buttonRef.current) === null || _buttonRef$current4 === void 0 ? void 0 : _buttonRef$current4.blur();
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement(getElementType(), getElementProps(), loading && ( /*#__PURE__*/_react.default.createElement(_loading.Loading, {
    thickness: size !== 'small' ? 2 : 1,
    className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(PREFIX, "-loading-icon"), true), "".concat(PREFIX, "-loading-icon-").concat(size), !!size), "".concat(PREFIX, "-icon-only"), iconOnly)),
    style: {
      color: 'currentColor'
    }
  })), !loading && icon && ( /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: (0, _classnames.default)("".concat(PREFIX, "-left-icon"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-icon-only"), iconOnly)),
    type: icon
  })), children && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-label")
  }, children), rightIcon && ( /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: (0, _classnames.default)("".concat(PREFIX, "-right-icon"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-icon-only"), iconOnly)),
    type: rightIcon
  })));
});
Button.displayName = 'Button';
var ButtonWidthLinkAndGroup = Object.assign(Button, {
  Link: _ButtonLink.default,
  ButtonGroup: _ButtonGroup.default
});
ButtonWidthLinkAndGroup.displayName = 'Button';
var _default = exports.default = ButtonWidthLinkAndGroup;